import { ORDER_MALLS, ORDER_MALL_LABELS } from '@/features/orders/lib/orderMall';
import type { HomeSectionProduct } from '../types/homeSection';

/**
 * QA-621 — 섹션 상품 매핑 행이 쇼핑몰 메인에 안 나오거나 일부 몰에서만 나오는 이유.
 * 공개 섹션 조건(catalog #122): 상태 SELLING·SOLD_OUT, 노출, 노출 기간 안, 노출 몰(빈 배열 = 전체).
 * 필드가 없거나 null 이면(구 응답·읽지 못한 상품) 그 조건은 표시하지 않는다.
 */
export interface SectionProductNote {
  key: string;
  label: string;
  /** hidden = 어느 몰에서도 안 나옴, partial = 일부 몰만. */
  kind: 'hidden' | 'partial';
}

const PUBLIC_STATUSES: ReadonlySet<string> = new Set(['SELLING', 'SOLD_OUT']);

const STATUS_LABELS: Record<string, string> = {
  STOPPED: '판매중지',
  DRAFT: '임시저장',
  PENDING_REVIEW: '검수대기',
};

export const sectionProductNotes = (row: HomeSectionProduct, now: Date = new Date()): SectionProductNote[] => {
  const notes: SectionProductNote[] = [];
  if (row.status && !PUBLIC_STATUSES.has(row.status)) {
    notes.push({ key: 'status', label: STATUS_LABELS[row.status] ?? `비공개 상태(${row.status})`, kind: 'hidden' });
  }
  if (row.displayed === false) {
    notes.push({ key: 'displayed', label: '숨김', kind: 'hidden' });
  }
  const t = now.getTime();
  if (row.displayStartAt && t < new Date(row.displayStartAt).getTime()) {
    notes.push({ key: 'window', label: '노출 전', kind: 'hidden' });
  } else if (row.displayEndAt && t >= new Date(row.displayEndAt).getTime()) {
    notes.push({ key: 'window', label: '노출 종료', kind: 'hidden' });
  }
  const malls = (row.visibleMallCodes ?? []).filter((m) => (ORDER_MALLS as readonly string[]).includes(m));
  if (malls.length > 0 && malls.length < ORDER_MALLS.length) {
    const ordered = ORDER_MALLS.filter((m) => malls.includes(m));
    notes.push({ key: 'malls', label: `${ordered.map((m) => ORDER_MALL_LABELS[m]).join('·')}만`, kind: 'partial' });
  }
  return notes;
};
